import { render, staticRenderFns } from "./AppUploadFile.vue?vue&type=template&id=ebb84406"
import script from "./AppUploadFile.vue?vue&type=script&lang=ts"
export * from "./AppUploadFile.vue?vue&type=script&lang=ts"
import style0 from "./AppUploadFile.vue?vue&type=style&index=0&id=ebb84406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports